import { getTermValue } from './helpers';
import { FDealType, FOfferType, type TJsonQuery } from './types';
import { getDealTypeFromJsonQuery, getOfferTypeFromJsonQuery } from './utils';

export function getIsEncumbranceRealty(jsonQuery: TJsonQuery): boolean | null {
  const dealType = getDealTypeFromJsonQuery(jsonQuery);
  const offerType = getOfferTypeFromJsonQuery(jsonQuery);

  const isSale = dealType === FDealType.Sale;
  const isFlat = (offerType & FOfferType.Flat) !== 0;

  if (!isSale || !isFlat) {
    return null;
  }

  return getTermValue('is_encumbrance_realty')(jsonQuery);
}
